import React, { useState } from 'react';
import homeImg from "Common/img/SVG/PhoenixHomeIcons.svg";
import watchListImg from "Common/img/SVG/PhoenixWatchlistIcons.svg";
import menuImg from "Common/img/SVG/PhoenixMenuIcons.svg";
import metricesImg from "Common/img/SVG/PhoenixMetricsIcons.svg";
import { getToken } from 'Global/AppService';
import * as TabsConstants from 'Tabs/TabsConstants';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { ROUTE_HOME,ROUTE_METRICS,ROUTE_RSU,ROUTE_ADMIN,ROUTE_METER, ROUTE_WATCHLIST,ROUTE_USER_SERACH_HISTORY,ROUTE_TRIGGERS, ROUTE_RULE_LIST } from 'Common/constants/commonConstants';
import fileImg from "Common/img/PNG/PhoenixFileAccessIcon.png";
import adminImg from "Common/img/SVG/PhoenixUserIcons.svg";
import {ADMIN_ROLE} from "Admin/store/AdminPageConstants"

import {isFeatureEnabled} from 'Common/utils/Utils'

const NavLeftOptions = ({adminData,featuresData,dispatch}) => {
    return (
        <ul data-testid="nav-bar-left-list" id="nav-left-menu" className="navbar-nav">
            <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_HOME}>
                    <img src={homeImg} className="nav-icons"></img> 
                    <div className="nav_headings">Home</div></NavLink>
            </li>
            <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_WATCHLIST}>
                    <img src={watchListImg} className="nav-icons"></img> 
                    <div className="nav_headings">Watchlist</div>
                </NavLink>
            </li>
            <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_USER_SERACH_HISTORY}>
                    <img src={watchListImg} className="nav-icons"></img> 
                    <div className="nav_headings">History</div>
                </NavLink>
            </li>
            {featuresData.isAllowedFeaturesFetched && featuresData.allowedFeatures && isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_RSU_DASHBOARD) && 
            <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_RSU}>
                    <img src={fileImg} className="nav-icons"></img>
                    <div className="nav_headings">RSU</div></NavLink>
            </li>}
            {featuresData.isAllowedFeaturesFetched && featuresData.allowedFeatures && isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_METRICS_DASHBOARD) && 
            <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_METRICS}>
                    <img src={metricesImg} className="nav-icons"></img> 
                    <div className="nav_headings">METRICS</div></NavLink>
            </li>}
            {featuresData.isAllowedFeaturesFetched && featuresData.allowedFeatures && isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_ADMIN) && 
            <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_ADMIN}>
                    <img src={adminImg} className="nav-icons"></img> 
                    <div className="nav_headings">ADMIN</div></NavLink>
            </li>
            }
            {featuresData.isAllowedFeaturesFetched && featuresData.allowedFeatures && isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_CREATE_TRIGGERS) &&
               <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_TRIGGERS}>
                    <img src={adminImg} className="nav-icons"></img> 
                    <div className="nav_headings">TRIGGERS</div></NavLink>
               </li>
            }
            {featuresData.isAllowedFeaturesFetched && featuresData.allowedFeatures && isFeatureEnabled(featuresData.allowedFeatures,TabsConstants.TAB_NAME_METERING) &&
               <li className="nav-item nav_min_width">
                <NavLink className="nav-link item-text nav-border-right" to={ROUTE_METER}>
                    <img src={adminImg} className="nav-icons"></img> 
                    <div className="nav_headings">METERING</div></NavLink>
               </li>
            }
            
            {/* <li className="nav-item nav_min_width">
                <a className="nav-link item-text nav-border-right" >
                    <img src={menuImg} className="nav-icons"></img> 
                    <div className="nav_headings">Menu</div>
                </a>
            </li> */}
        </ul>
    )
}


function select(state) {
    return {
        featuresData:state.allowedFeaturesReducer,
        adminData:state.AdminPageReducer
    };
}
export default connect(select)(NavLeftOptions)